import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const ContactUsPost = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/contact/us', body);
  return data;
});
